import { computed } from 'vue'

import type { ComputedRef } from 'vue'
import type { TutorCategoryType } from '@entities/tutor'

import { useTutorKanbanStore } from './store'

interface PaymentPolicyRowOptions {
  category: TutorCategoryType
}

interface PaymentPolicyRowReturn {
  refValue: ComputedRef<string>
}

export const usePaymentPolicyRow = ({ category }: PaymentPolicyRowOptions): PaymentPolicyRowReturn => {
  const tutorKanbanStore = useTutorKanbanStore()

  const refValue = computed<string>(() => {
    const policies = tutorKanbanStore.getTutor?.payment_policies ?? []
    const policy = policies.find(item => item.pivot?.category === category)
    return policy?.name ?? '-'
  })

  return {
    refValue,
  }
}
